import { render, staticRenderFns } from "./WikiHome.vue?vue&type=template&id=3e2795d6"
import script from "./WikiHome.vue?vue&type=script&lang=js"
export * from "./WikiHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports